import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { HorizontalBar } from 'react-chartjs-2';
import { InformationTitle } from '../../../CampaignDetails/CampaignDetails.styles';
import { BarChartProps } from './BarChart.interface';
import { BarOptions } from './BarOptions';

export function BarChart({ data, title }: BarChartProps) {
    const [containerChartHeight, setContainerChartHeight] = useState(100);
    useEffect(() => {
        if (data.labels && data.labels.length > 3) {
            setContainerChartHeight(data.labels.length * 30)
        } 
    }, [])
    return (
        <>
            <InformationTitle>{title}</InformationTitle>
            <div className="chart" style={{ position: 'relative', height: `${containerChartHeight}px` }}>
                <HorizontalBar
                    data={data}
                    options={BarOptions(isMobile)}
                />
            </div>
        </>
    )
}
